import { defaultAppConfig } from '@shared-core/features/config/configs/defaults'
import { createAsyncThunk } from '@shared-core/store/utils'
import type { MobileConfig } from '../models/config'
import { ConfigStatus } from '../models/types'
import { selectedAppConfig } from '../selectors'
import { patchConfigState } from '../slice'

export const setAppConfig = createAsyncThunk(
  'config/setAppConfig',
  (config: MobileConfig | null, { dispatch, getState }) => {
    if (config) {
      const currentConfig = selectedAppConfig(getState())
      // надо деструктурировать иначе падает так как не может смерджить объект по ссылке
      const currentLinks = { ...(currentConfig?.links || {}) }
      // устанавливаем дефолтные ссылки, которые знаем, чтобы, если бекенд ничего не прислал - у нас работало
      const links = Object.assign(currentLinks, config.links || {})
      dispatch(patchConfigState({ appConfig: { ...config, links } }))
    }
  },
)

// В API v1 нет конфигурационных эндпоинтов; используем настройки приложения.
export const fetchConfigApp = createAsyncThunk('config/fetchConfigApp', (_, { dispatch }) => {
  dispatch(setAppConfig(defaultAppConfig))
  dispatch(patchConfigState({ appConfigStatus: ConfigStatus.loaded }))
  return defaultAppConfig
})

export const fetchConfigGlobal = createAsyncThunk('config/fetchConfigGlobal', (_, { dispatch }) => {
  dispatch(patchConfigState({ globalConfigStatus: ConfigStatus.failed, globalConfig: null }))
  return null
})

export const fetchConfigCountries = createAsyncThunk('config/fetchConfigCountries', (_, { dispatch }) => {
  dispatch(patchConfigState({ countriesStatus: ConfigStatus.loaded, countries: [] }))
  return []
})

export const fetchConfigCountryByCode = createAsyncThunk(
  'config/fetchConfigCountryByCode',
  (_countryCode: string, { dispatch }) => {
    dispatch(patchConfigState({ countryConfigStatus: ConfigStatus.failed, countryConfig: null }))
    return null
  },
)

export const fetchConfigVcardLimits = createAsyncThunk('config/fetchConfigVcardLimits', (_, { dispatch }) => {
  dispatch(patchConfigState({ vcardLimitsStatus: ConfigStatus.loaded, vcardLimits: [] }))
  return []
})
